module.exports = __webpack_public_path__ + "img/shamcash_logo.1d867e28.svg";